import {
  TX_CALLBACK_SUCCESS,
  TX_CALLBACK_REQUEST,
  TX_CALLBACK_FAILURE,
  TX_CALLBACK_RESET,
} from '../actions/transaction_callback'

export function transactionCallback(
  state = {
    isFetching: false,
    results: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case TX_CALLBACK_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }

    case TX_CALLBACK_SUCCESS:
      return {
        ...state,
        isFetching: false,
        results: action.response,
      }
    case TX_CALLBACK_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error }
    case TX_CALLBACK_RESET:
      return { ...state, results: null, errorMessage: null, isFetching: false }
    default:
      return state
  }
}
